import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';

import { setDestinationGha } from '../../../store/actions/ghaAction';
import { setDestinationPort }  from '../../../store/actions/portAction';
import { receiveAwbs, receiveGhaAwbs, receiveGhaOrderAwbs } from '../../../store/actions/awbsAction';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import { updateWholeCart } from '../../../store/actions/cartAction';
import { fetchFinish, fetchPending } from '../../../store/actions/fetchingAction';
import { History } from 'history';

import awbRemote from '../../../api/awbRemote';
import cartRemote from '../../../api/cartRemote';
import paymentRemote from '../../../api/paymentsRemote';

import Awbs from './Awbs';
import PrevNext from '../../prevAndNext/PrevNext';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import ProcessBarContainer from '../../processBar/ProcessBarContainer';
import AddAWBModalContainer from '../addAWBModal/AddAWBModalContainer';
import PoDModalContainer from '../../poD/PoDModalContainer';

import Awb from '../../../models/Awb';
import Cart from '../../../models/Cart';
import AwbPart, { AwbPartStatuses } from '../../../models/AwbPart';
import CartItem from '../../../models/CartItem';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import ManualEntryEdit from '../../../models/ManualEntryEdit';
import { UserRoleType } from '../../../models/User';
import PaymentsDetail, { PaymentDetailsAwb } from '../../../models/PaymentDetails';

import { AWB_SCHEMA } from '../../../utils/airwayBill';
import { getAwbPartStatuses } from '../../../store/actions/awbPartStatusesAction';
import AttachmentsContainer from '../../attachments/AttachmentsContainer';

import commonStyles from '../../common/common.module.css';
import PaymentsModal from './PaymentsModal';
import { baseUrl } from '../../../api/baseUrl';
import MissingPaymentsModalContainer from '../additionalPayments/AdditionalPaymentsContainer';
import AdditionalServicesModalContainer from '../../cart/additionalServices/additionalServicesModal/AdditionalServicesModalContainer';

interface AwbsProps {
  location?: any;
  userRole: UserRoleType;
  awbs: Array<Awb>;
  ghaAwbs: Array<Awb>;
  history: History;
  cart: Array<CartItem>;
  port: string;
  gha_id: number;
  availableAwbPartStatuses: AwbPartStatuses;
  onReceiveAwbs: Function;
  onReceiveGhaAwbs: Function;
  onExistAirwayBill: Function;
  setDestinationPort: Function;
  setDestinationGha: Function;
  receiveSuccess: Function;
  receiveError: Function;
  updateCart: Function;
  fetchFinish: Function;
  fetchPending: Function;
  getAvailableAwbPartStatuses: Function;
  getGhaOrderAwbs: (orderNumber: string) => void;
  manualEntryEdit: ManualEntryEdit;
  type?: string;
};

interface AwbsState {
  isModalOpen: boolean;
  requestId?: string;
  awb: Awb;
  isAwbDeletionConfirmationOpen: boolean;
  isSyncingConfirmationOpen: boolean;
  code: string;
  number: string;
  showNextButton: boolean;
  didUpdates: number;
  isAttachmentsDialogOpen: boolean;
  isModalPoDOpen: boolean;
  completed: boolean;
  paid: boolean;
  unpaid: boolean;
  awbNumber: string;
  sortby: string;
  filterby : string;
  paymentReceiptModal: boolean;
  payments: PaymentDetailsAwb;
  addPaymentsModal: boolean;
  view: string;
  version: number;
};

class AwbsContainer extends PureComponent <AwbsProps, AwbsState> {

  state: AwbsState = {
    isModalOpen: false,
    requestId: '',
    awb: AWB_SCHEMA,
    isAwbDeletionConfirmationOpen: false,
    isSyncingConfirmationOpen: false,
    code: '',
    completed: false,
    paid: false,
    unpaid: false,
    number: '',
    showNextButton: false,
    didUpdates: 0,
    isAttachmentsDialogOpen: false,
    isModalPoDOpen: false,   
    awbNumber: '',
    sortby: 'creation_date',
    filterby: 'all',
    paymentReceiptModal: false,
    payments: {} as PaymentDetailsAwb,
    view: 'render',
    version: 0,
    addPaymentsModal: false,
  };

  componentDidMount(): void {

    if (this.props.userRole === UserRoleType.FORWARDER) {
      this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);

      if (this.props.availableAwbPartStatuses.import.length === 0) {
        this.props.getAvailableAwbPartStatuses();
      }
    } else {

      const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;

      if (manualEntryEdit && manualEntryEdit.isEditMode) {

        this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber); 
      } else {

        this.props.onReceiveGhaAwbs();
      }
    }

  }

  componentDidUpdate(prevProps: AwbsProps): void {

    const cartItemsLength: number = this.props.cart.length;

    if (cartItemsLength > 0 && this.state.didUpdates < 2) {
      
      this.showHidePreviousButton(cartItemsLength);
      this.setState({ didUpdates: this.state.didUpdates + 1 });
    }

    if (this.props.userRole === UserRoleType.FORWARDER) {

      const newProps: AwbsProps = this.props;

      if (prevProps.port !== newProps.port || prevProps.gha_id !== newProps.gha_id) {
        this.props.onReceiveAwbs(newProps.port, newProps.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      };
    } else  {

      const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;

      if (prevProps.ghaAwbs === this.props.ghaAwbs) { // ?????  CALLED 2 TIMES ! ???


        if (manualEntryEdit && manualEntryEdit.isEditMode) {

          this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber); 
        } else {

          this.props.onReceiveGhaAwbs();
        }
      }
    }
  };

  handleOpenParts = (awb: Awb, requestId?: string): void => {

    this.setState({ isModalOpen: true, awb, requestId });
  };

  handleDelete = (code: string, number: string): void => {

    this.setState({ isAwbDeletionConfirmationOpen: true, code, number });
  };

  handleEdit = (awbData: Awb, opt: {edit: boolean, metadata: boolean}): Promise<any> | void => {

    if( opt.edit) {

    return awbRemote.editAwb(awbData, this.state.requestId).then((resp: ApiResponse<Awb>) => {

      const awb: Awb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awb) {
          if(this.props.type === 'go') {
            const isTrueFlag = (value: any): boolean => value === true || value === 1 || value === '1' || value === 'true';
            const selectedParts = (awb.import_parts || []).filter((part: any) => isTrueFlag(part.added) && !isTrueFlag(part.in_order));

            // For GO, apply selected part(s) immediately when adding the AWB.
            if (selectedParts.length > 0) {
              return (async () => {
                let lastResp: any = null;
                for (const part of selectedParts) {
                  const partId = part.id || `${part.flight_no}-${part.flight_date}`;
                  lastResp = await cartRemote.addAirwayBillPartToCart(awb.code, awb.number, awb.version || 0, partId, true);
                  if (lastResp?.error) {
                    this.props.receiveError(lastResp.error);
                    return;
                  }
                }

                this.props.fetchFinish();
                this.setState({ isModalOpen: false }, () => {
                  this.props.history.push('/pay-go');
                });
              })();
            }

            return cartRemote.addAirwayBillToCart(awb.code, awb.number, awb.version || 0).then((cartResp) => {
              this.props.fetchFinish();
              if (cartResp.result) {
                this.setState({ isModalOpen: false }, () => {
                  this.props.history.push('/pay-go');
                });
              } else if (cartResp.error) {
                this.props.receiveError(cartResp.error);
              }
            });
          }

          if(this.props.userRole === UserRoleType.FORWARDER) {
            const arrivalPort = awb.destination;
            const gha = awb.id_gha_dst;

            if (this.props.port === arrivalPort && this.props.gha_id === gha) {

              this.props.onReceiveAwbs(arrivalPort, gha, this.state.completed, this.state.paid, this.state.unpaid, undefined, this.state.sortby, this.state.filterby);

            } else {
              this.props.setDestinationPort(arrivalPort);
              this.props.setDestinationGha(gha);
            };
          };

          if(this.props.userRole === UserRoleType.GHA && this.props.type !== 'go') {
            this.props.onReceiveGhaAwbs(false);
          }        };

      if (error) {
        this.props.receiveError(error);
      };
      

      this.setState({ isModalOpen: false });
    });
  } else {
    this.setState({ isModalOpen: false });
  }
  };

  handleSync = (code: string, number: string): void => {
    
    this.setState({ isSyncingConfirmationOpen: true, code, number });
  };

  openReceipt = (code: string, number: string): void => {
    let url: string = `${baseUrl}payment/${code}/${number}/file`;
    this.setState({ view: 'print' }, () => {
      window.print();
      this.setState({ view: 'render'});
    });
    // this.setState({ view: 'render' })
  }

  syncAwb = (code?: string, number?: string): void => {

    code = code || this.state.code;
    number = number || this.state.number;

    let awbNumber: string = `${code}-${number}`;
    this.setState({ isModalOpen: false, isSyncingConfirmationOpen: false });

    this.props.fetchPending();
    awbRemote.extractAwb(awbNumber, 'import').then((resp: {awbData: Awb, requestId: string}) => {

      let { awbData, requestId } = resp;
      this.handleOpenParts(awbData, requestId);
      this.props.fetchFinish();
    }, (err) => {
      this.props.fetchFinish();
      this.props.receiveError(err);
    });
  };

  closeConfirmationDialogs = (): void => {

    this.setState({ isAwbDeletionConfirmationOpen: false, code:'', number:'' });
  };

  deleteAwb = (): void => {

    awbRemote.deleteAwb(this.state.code, this.state.number).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        if( this.props.userRole === UserRoleType.FORWARDER)
          this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid,  undefined, this.state.sortby, this.state.filterby);
        if(this.props.userRole === UserRoleType.GHA)
          this.props.onReceiveGhaAwbs(false);
      };

      if (error) {
        this.props.receiveError(error);
      };
      
      this.closeConfirmationDialogs();
    });
  };

  applyStorage = (code: string, number: string): void => {

    awbRemote.addStorage(code, number).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;
        if (manualEntryEdit && manualEntryEdit.isEditMode) {

          this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber); 
        } else {
          this.props.onReceiveGhaAwbs(false);
        }
      };

      if (error) {
        this.props.receiveError(error);
      };
      
    });
  };

  handleStatusChange = (type: string, event: any): void => {
    const value = event.target.value;
        
    if (value === 'all') {
      this.setState({ filterby: value }, () => {
        this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });

    } else if (value === 'paid') {
      const paid = !this.state.paid;
      this.setState({ filterby: value }, () => {
        this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });
    } 
    else if (value === 'unpaid') {
      const unpaid = !this.state.unpaid;
        this.setState({ filterby: value }, () => {
          this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });  
    }
    
  };
  
  showCompletedAwbs = (type: string): void => {
    if(type == 'complete') {
      const completed = !this.state.completed;
      this.setState({ completed }, () => {
        this.props.onReceiveAwbs(this.props.port, this.props.gha_id, completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });
    } else {
      const paid = !this.state.paid;
      this.setState({ paid }, () => {
        this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });
    }
  }

  openModal = (awb: Awb): void => {

    this.setState({ paymentReceiptModal: true, awb }, () => {
      paymentRemote.getPaymenAwbDetails(awb.code, awb.number, awb.version, awb.order_number).then((resp: ApiResponse<PaymentDetailsAwb>) => {

        const paymentDetail: PaymentDetailsAwb | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (paymentDetail) {

          this.setState({ payments: paymentDetail });
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
    });

  }

  onChange = (type: string, event: any): void => {
    const value = event.target.value;
    if(type === 'awb') {
      this.setState({ awbNumber: value });
    } else {
      this.setState({ sortby: value }, () => {
        this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
      });
    }
  }

  searchAwb = (): void => {
    this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby, this.state.filterby);
  }

  checkAirwayBillIsInTheCart = (number: string, code: string, version: number): void => {

    const found: CartItem | undefined = this.findInCart(number, code);

    if (found) {

      const error: ResponseError = {
        errorCode: '',
        longDescription: 'Airwaybill is already in your cart!'
      };

      this.props.onExistAirwayBill(error);

    } else {
      const edit = this.props.manualEntryEdit && this.props.manualEntryEdit.isEditMode ? this.props.manualEntryEdit.orderNumber : '';
      cartRemote.addAirwayBillToCart(code, number, version, edit).then((resp: ApiResponse<Cart>) => {

        const cart: Cart | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        const cartItemsLength: number = (cart && cart.cart) ? cart.cart.length : 0;

        if (cart) {
          this.props.updateCart(cart);
          this.showHidePreviousButton(cartItemsLength);
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
      
    }
  }

  enableCartIcon = (number: string, code: string): boolean => {

    const foundAwb: Awb | undefined = this.findInAwb(number, code);
    const foundCart: CartItem | undefined = this.findInCart(number, code);

    if (foundAwb && foundCart) {
      return foundAwb.import_parts.length !== foundCart.parts.length;
    }

    return foundCart === undefined;
  }

  findInAwb = (number: string, code: string): Awb | undefined => {

    return this.props.awbs.find((awbElement: Awb) => {
      return awbElement.code === code && awbElement.number === number;
    });
  };

  clearAwbSearch = () => {
    this.setState({ awbNumber: '' }, () => {
      this.props.onReceiveAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.paid, this.state.unpaid, this.state.awbNumber, this.state.sortby,this.state.filterby);
    })
  }

  findInCart = (number: string, code: string): CartItem | undefined => {
    
    return this.props.cart.find((cartElement: CartItem) => {
      return cartElement.code === code && cartElement.number === number;
    });
  };

  openAttachments = (code: string, number: string, version: number): void => {
    this.setState({ isAttachmentsDialogOpen: true, code, number, version});
  };


  handleOpenModal = (): void => {
      
  }

  openPaymentsModal = (awb: Awb): void => {
    this.setState({ addPaymentsModal: true, awb }, () => {
      const edit = this.props.manualEntryEdit && this.props.manualEntryEdit.isEditMode ? this.props.manualEntryEdit.orderNumber : '';
      cartRemote.addAirwayBillToCart(awb.code, awb.number, awb.version, edit).then((resp: ApiResponse<Cart>) => {

        const cart: Cart | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        const cartItemsLength: number = (cart && cart.cart) ? cart.cart.length : 0;

        if (cart) {
          this.props.updateCart(cart);
          this.showHidePreviousButton(cartItemsLength);
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
    });
  }

  closeAttachments = (): void => {
    this.setState({ isAttachmentsDialogOpen: false, code: '', number: ''  });
  };

  checkTotalPcsAndWgt = (pieces: string, weight:string, parts: Array<AwbPart>): boolean => {

    const totalPcs: number = +(pieces); 
    let sumPcs: number = parts.reduce((total, part) => { 
       return (total + +(part.pieces));
    }, 0);

    let totalWeight: number = +(weight);
    let sumWgt: number = parts.reduce((total, part) => { 
      return (total + +(part.weight));
    }, 0);
  
    if (totalWeight !== sumWgt || totalPcs !== sumPcs) {
      return true;
    };

    return false;
  };
  
  showHidePreviousButton = (cartItemsLength: number): void => {

    const show: boolean = cartItemsLength > 0;
    this.setState({ showNextButton: show });
  }

  handleOpenPoD = (code: string, number: string, version: number): void => {

    this.setState({ isModalPoDOpen: true, code, number, version });
  };

  handleCloseModal = (modalType: string): void => {

    if (modalType === 'import') {
      this.setState({ isModalOpen: false });
    }

    if (modalType === 'pod') {
      this.setState({ isModalPoDOpen: false, code: '', number: ''});
    }

    if (modalType === 'payment') {
      this.setState({ paymentReceiptModal: false});
    }

    if (modalType === 'missing_payment') {
      this.setState({ addPaymentsModal: false});
    }
  }

  render() {

    const showNextButton: boolean = this.state.showNextButton;
    const awbs = this.props.userRole === UserRoleType.FORWARDER ? this.props.awbs : this.props.ghaAwbs;
    const nextBtnHref: string = this.props.userRole === UserRoleType.FORWARDER ? ((this.props as any).type === 'go' ? '/cart-go' : '/cart') : '/manual-entry-cart';

    return (
      <Fragment>
        <div className={ commonStyles.headerDummyDiv }></div>
        <ProcessBarContainer type='import' userRole={this.props.userRole}/>
        <Awbs
          awbs={ awbs }
          openParts={ this.handleOpenParts }
          deleteAwb={ this.handleDelete }
          enableCartIcon={ this.enableCartIcon }
          checkAirwayBillIsInTheCart={ this.checkAirwayBillIsInTheCart }
          checkTotalPcsAndWgt={ this.checkTotalPcsAndWgt }
          onSyncClick={ this.handleSync }
          handleOpenPoD={ this.handleOpenPoD }
          openAttachments={ this.openAttachments }
          userRole={ this.props.userRole }
          applyStorage={ this.applyStorage }
          editAwb={ this.props.manualEntryEdit && this.props.manualEntryEdit.isEditMode }
          completeAwbs={ this.showCompletedAwbs }
          completed={ this.state.completed }
          awbNumber={ this.state.awbNumber }
          searchAwb={ this.searchAwb }
          onChange={ this.onChange }
          handleStatusChange={ this.handleStatusChange }
          paid={ this.state.paid }
          unpaid={ this.state.unpaid }
          sortValue={ this.state.sortby }
          filterValue={ this.state.filterby }
          openPayments={ this.openModal }
          clearAwb={ this.clearAwbSearch }
          openPaymentModal={this.openPaymentsModal}
        />
        
        { showNextButton &&
          <PrevNext nextButton={ { active: true, href: `${nextBtnHref}`, animate: true } } />
        }

        { this.state.isAwbDeletionConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isAwbDeletionConfirmationOpen }
            close={() => { this.setState({ isAwbDeletionConfirmationOpen: false }) }}
            title='Delete Confirmation'
            text='Are you sure you want to delete this airwaybill?'
            textConfirm='delete'
            confirm={ this.deleteAwb } 
            showCloseIcon={ true }
          />
        }
        { this.state.isSyncingConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isSyncingConfirmationOpen }
            close={() => { this.setState({ isSyncingConfirmationOpen: false }) }}
            title='Sync confirmation'
            text={`Are you sure you want to sync ${this.state.code}-${this.state.number}?`}
            textConfirm='sync'
            confirm={ () => this.syncAwb() } 
            showCloseIcon={ true }
          />
        }
        { this.state.isModalOpen && 
          <AddAWBModalContainer
            modalOpen={ this.state.isModalOpen }
            awb={ this.state.awb }
            handleSave={ this.handleEdit }
            handleCloseModal={ this.handleCloseModal }
            handleSync={ this.syncAwb }
            awbActionOfUpdateButton={'add'}
            handleOpenPoD={ this.handleOpenPoD }
          />
        }
        { this.state.isModalPoDOpen && 
         <PoDModalContainer 
          isModalOpen={ this.state.isModalPoDOpen }
          handleCloseModal={ this.handleCloseModal }
          code={ this.state.code }
          number={ this.state.number }
          version={ this.state.version }
          />
        }
        { this.state.isAttachmentsDialogOpen && 
          <AttachmentsContainer
            code = {this.state.code}
            number = {this.state.number}
            version={this.state.version}
            process = {'import'}
            closeAttachments = {this.closeAttachments}
            refreshAwbs={true}
          />
        }
        { this.state.paymentReceiptModal && 
          <PaymentsModal
            awb={ this.state.awb }
            handleClose = { this.handleCloseModal }
            payments={ this.state.payments }
            printReceipt={ this.openReceipt }
            view={ this.state.view }
          />
        }

        { this.state.addPaymentsModal &&
          <MissingPaymentsModalContainer 
            modalOpen={ this.state.addPaymentsModal }
            handleCloseModal={ this.handleCloseModal }
            awbNumber={ this.state.awb.code + '-' + this.state.awb.number }
            awb={ this.state.awb }
            selectedAwbCode={ this.state.awb.code }
            selectedAwbNumber={ this.state.awb.number }
            history={ this.props.history }
          />
        }
      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    awbs: state.awbs.awbs,
    ghaAwbs: state.awbsGha,
    cart: state.cart.items,
    port: state.destinationPort,
    gha_id: state.destinationGhaId,
    availableAwbPartStatuses: state.awbPartStatuses,
    manualEntryEdit: state.manualEntryEdit
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    onReceiveAwbs: (port: string, gha: number, delivered: boolean, paid: boolean, unpaid: boolean, keyword: string, sort: string, filter: string) => dispatch(receiveAwbs(port, gha, delivered, paid, unpaid, keyword, sort, filter)),
    onReceiveGhaAwbs: (isExport: boolean) => dispatch(receiveGhaAwbs(isExport)),
    getAvailableAwbPartStatuses: () => dispatch(getAwbPartStatuses()),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
    onExistAirwayBill: (error: ResponseError) => dispatch(receiveError(error)),
    updateCart: (cart: Cart) => dispatch(updateWholeCart(cart)),
    setDestinationPort: (port: string) => dispatch(setDestinationPort(port)),
    setDestinationGha: (gha: number) => dispatch(setDestinationGha(gha)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending()),
    getGhaOrderAwbs: (orderNumber: string) => dispatch(receiveGhaOrderAwbs(orderNumber))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AwbsContainer);
